import { createContext } from 'react';
export var LiveChatLoaderContext = /*#__PURE__*/createContext({});